var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "nav",
    [
      _vm.step > 1
        ? [
            _c(
              "button",
              {
                staticClass: "btn inverse",
                on: {
                  click: function($event) {
                    _vm.goto(_vm.step - 1)
                  }
                }
              },
              [_vm._v(_vm._s(_vm._f("trans")("buttons.back")))]
            ),
            _vm._v(" "),
            _c("button", {
              staticClass: "arrow prev",
              on: {
                click: function($event) {
                  _vm.goto(_vm.step - 1)
                }
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.step < _vm.lastvalid
        ? [
            _c(
              "button",
              {
                staticClass: "btn",
                attrs: { disabled: !_vm.pagevalid[_vm.step - 1] },
                on: {
                  click: function($event) {
                    _vm.goto(_vm.step + 1)
                  }
                }
              },
              [_vm._v(_vm._s(_vm._f("trans")("buttons.next")))]
            ),
            _vm._v(" "),
            _c("button", {
              staticClass: "arrow next",
              attrs: { disabled: !_vm.pagevalid[_vm.step - 1] },
              on: {
                click: function($event) {
                  _vm.goto(_vm.step + 1)
                }
              }
            })
          ]
        : _vm._e(),
      _vm._v(" "),
      _vm.step === _vm.lastvalid
        ? [
            _c(
              "button",
              {
                staticClass: "btn",
                attrs: { disabled: !_vm.pagevalid[_vm.step - 1] },
                on: { click: _vm.submit }
              },
              [_vm._t("default")],
              2
            )
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-475ff3d8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-475ff3d8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/helpers/mixins/steps/PrevNext.vue
// module id = null
// module chunks = 